<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size md_size">
                <a href="javascript:" class="ui_close" type="button" @click="$emit('close')">
                    <span class="sr_only"></span>
                </a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <i v-if="'WFA' === param.flowStatus">{{ $t('TITLE.GLOBAL.ANSWERERS') }}</i>
                        <i v-else>{{ $t('TITLE.POPUP.SEARCH.USER') }}</i>
                    </dt>
                    <dd>
                        <!-- Grid -->
                        <div class="grid_wrap only_grid">
                            <toast-grid
                                :gridId="gridId"
                                :columns="columns"
                                :data="gridData"
                                :options="options"
                                :ref="gridId"
                                :key="gridKey"
                                :pageOptions="pageOptions"
                                :isTotalCount="true"
                                @mouseover="onMouseover"
                            />
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';
import $ from 'jquery';
import store from '@/vuex/store';
import SDLUtil from '@/utils/SDLUtil';
import ToastGrid from '~c/ToastGrid';

export default {
    name: 'userListPopup',
    components: {
        'toast-grid': ToastGrid,
    },
    props: {
        param: {},
    },
    data() {
        return {
            pageName: 'userListPopup',
            gridKey: 0,
            gridId: 'userListPopupGrid',
            columns: [
                {
                    header: SDLUtil.getMsgProp('FIELD.USER.ID'),
                    name: 'USER_ID',
                    align: 'center',
                    width: 140,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.USER.NAME'),
                    name: 'LOGIN_NAME',
                    align: 'center',
                    width: 140,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.EMPLOYEE.ID'),
                    name: 'LOGIN_EMPLOYEE',
                    align: 'center',
                    width: 140,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.LEVEL'),
                    name: 'DEPT_LEVEL_NM',
                    align: 'center',
                    width: 140,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.DEPARTMENT'),
                    name: 'DEPT_NM',
                    align: 'center',
                    // width: 200,
                    resizable: true,
                    sortable: false,
                },
            ],
            gridData: [],
            options: {
                scrollY: true,
                scrollX: false,
                minBodyHeight: 80,
                bodyHeight: 265,
            },
            pageOptions: {
                useClient: true,
                perPage: Number(localStorage.getItem('listRows')),
            },
        };
    },
    mounted() {
        this.onSearch(this.param);
    },
    methods: {
        async onSearch(param) {
            SDLUtil.showLoadingBar(true);
            return axios
                .post(`${SDLUtil.API_URL}/basis/common/qna/userPopupList.skp`, qs.stringify(param))
                .then(resp => {
                    this.gridData = resp.data.result.rowData;
                    this.gridKey++;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        onMouseover({nativeEvent, rowKey, columnName, instance}) {
          // Occurs when a mouse pointer is moved onto the Grid.
          if(columnName === 'USER_ID') {
            console.log(instance.getRow(rowKey))
            nativeEvent.target.title = instance.getRow(rowKey).REAL_ID
          }
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/faq/popup/userListPopup.vue